import USGSMap from '../features/USGSMap/index.web';

const USGSMapWidget = () => <USGSMap widget />;

export default USGSMapWidget;
